import type { DiamIdentity, DiamTeamMembership } from '../../diamApi';
import {
  IDENTITY_STATUS,
  Identity,
  IdentityAssignment,
  IdentityDisplayStatus,
} from './types';

function mapIdentityType(type: DiamIdentity['type'] | undefined): string {
  if (type === 'HUMAN') {
    return 'Human';
  }

  return type ?? '';
}

export function mapIdentityStatus(
  identity: DiamIdentity,
  membership?: DiamTeamMembership,
): IdentityDisplayStatus {
  if (identity.isActive === false) {
    return IDENTITY_STATUS.DEACTIVATED;
  }

  if (membership?.suspension?.isSuspended) {
    return IDENTITY_STATUS.SUSPENDED;
  }

  return IDENTITY_STATUS.ACTIVE;
}

export function mapMembershipRolesToAssignments(
  membership?: DiamTeamMembership,
): IdentityAssignment[] {
  return (membership?.roles ?? []).map(role => ({
    id: role.roleId,
    name: role.name,
    roleId: role.roleId,
    attributeIds: (role.attributes ?? [])
      .map(attribute => attribute.name)
      .filter(name => Boolean(name)),
  }));
}

export function mapApiIdentity(
  identity: DiamIdentity,
  membership?: DiamTeamMembership,
): Identity {
  return {
    id: identity.id,
    name: identity.name ?? '',
    email: identity.email ?? '',
    type: mapIdentityType(identity.type),
    teams: (identity.teams ?? []).map(team => team.name),
    accessCategory: identity.isInternal ? 'Internal' : 'External',
    phoneNumber: identity.phone ?? '',
    assignments: mapMembershipRolesToAssignments(membership),
    status: mapIdentityStatus(identity, membership),
    createdAt: identity.createdDate ?? '',
  };
}

export function mapApiIdentityFromMembership(
  membership: DiamTeamMembership,
): Identity | undefined {
  const summary = membership.identity;
  if (!summary?.id) {
    return undefined;
  }

  const identityForStatus: DiamIdentity = {
    id: summary.id,
    type: summary.type ?? 'HUMAN',
    name: summary.name,
    email: summary.email,
    isActive: true,
    createdDate: membership.createdDate,
  };

  return mapApiIdentity(identityForStatus, membership);
}
